/* eslint-disable @typescript-eslint/no-explicit-any -- the field value is whatever the form holds */

/**
 * The `value` handed to MUI's `<Autocomplete />` for the form field's current value.
 *
 * A single select with `valueContainsLabel` and nothing chosen gives `null`. It used to give a
 * `{ label: "", value: "" }` sentinel, which matches no option, so MUI warned "The value provided
 * to Autocomplete is invalid" on every render of an empty field. Every other branch is unchanged.
 */
export function autocompleteValue({
  value,
  isMultiple,
  valueContainsLabel,
}: {
  value: any;
  isMultiple?: boolean;
  valueContainsLabel?: boolean;
}): any {
  if (isMultiple) {
    if (valueContainsLabel) {
      if (value?.length) return value;
      else return [];
    } else {
      if (value) return Array.isArray(value) ? value : [value];
      else return [];
    }
  } else {
    if (valueContainsLabel) {
      if (value?.label) return value;
      else return null;
    } else {
      if (value) return value;
      else return null;
    }
  }
}
